import { render } from "./QAnalyticsPreloader.vue?vue&type=template&id=640a9b02&scoped=true"
const script = {}

import "./QAnalyticsPreloader.vue?vue&type=style&index=0&id=640a9b02&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640a9b02"]])

export default __exports__